<script setup lang="ts">
interface IProps {
  width: string
  height: string
}

const props = defineProps<IProps>()

const borderWidth = computed(() => {
  return parseInt(props.width) / 10 + 'px'
})
</script>

<template>
  <div class="spinner" />
</template>

<style scoped lang="scss">
.spinner {
  @apply rounded-full border-t-primary border-r-primary border-b-transparent border-l-transparent;
  border-width: v-bind(borderWidth);
  width: v-bind(width);
  height: v-bind(height);

  @keyframes turn {
    from {
      transform: rotate(0deg);
    }

    to {
      transform: rotate(359deg);
    }
  }

  animation: turn 1.5s infinite linear;
}
</style>